<template>
  <v-card class="full-height">
    <v-card-text class="py-2 full-height d-flex flex-column">
      <v-row dense>
        <v-col cols="auto" class="subtitle-1 lighttext--text my-auto">
          {{ typeName }}
        </v-col>
        <v-spacer></v-spacer>
        <v-col cols="auto" class="px-0">
          <v-menu absolute>
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" icon>
                <v-icon>
                  more_vert
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="$emit('edit')">
                <v-list-item-icon>
                  <v-icon>edit</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Edit</v-list-item-title>
              </v-list-item>
              <v-list-item @click="$emit('delete')">
                <v-list-item-icon>
                  <v-icon>delete</v-icon>
                </v-list-item-icon>
                <v-list-item-title>Delete</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="12" class="pa-0">
          <v-card-title class="py-0 px-1 secondary--text">
            {{ customField.name }}
          </v-card-title>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  name: "CustomFieldCard",
  props: { customField: { type: Object } },
  data: () => ({}),
  computed: {
    typeName() {
      return this.types
        .filter(x => x.id == this.customField.typeId)
        .map(x => x.name)[0];
    },
    ...mapGetters({ types: "lookup/custom_field_types" })
  },
  created() {},
  methods: {}
};
</script>
